import React from "react";
import "./ResponceDetails.css";

const ResponceDetails = ({ show, onClose, documentData }) => {
  if (!show || !documentData) return null;

  const { serial_number, values_json } = documentData;

  return (
    <div
      className="offcanvas-backdrop-custom"
      style={{ display: show ? "block" : "none" }}
    >
      <div
        className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
        tabIndex="-1"
        style={{ visibility: show ? "visible" : "hidden" }}
      >
        {/* Header */}
        <div className="border-bottom d-flex justify-content-start align-items-center p-2">
          <button
            type="button"
            className="btn-close me-2"
            onClick={onClose}
          ></button>
          <h5 className="Responce-title">
            Dossier n° :{" "}
            <span style={{ fontWeight: "600" }}>
              {serial_number || "—"}
            </span>
          </h5>
        </div>

        {/* Body */}
        <div className="offcanvas-body">
          {values_json && Object.keys(values_json).length > 0 ? (
            Object.entries(values_json).map(([key, value], index) => (
              <div
                key={index}
                className="doc-attr py-1 px-4 d-flex flex-column justify-content-start align-items-start mb-3"
              >
                <span className="doc-label d-block">{key}</span>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <span
                    className="doc-span"
                    style={{ fontWeight: "500", fontSize: "0.9rem" }}
                  >
                    {typeof value === "boolean"
                      ? value
                        ? "Oui"
                        : "Non"
                      : value?.toString() || "-"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted text-center mt-3">
              Aucune réponse enregistrée.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResponceDetails;
